import { BackButton } from '@exam-management/components';
import { PageHeader } from '@shared/components';

export default function QuestionReviewTaskCreationHeader() {
  return <PageHeader title='Create Task: Question Review' linkAdornment={<BackButton />} />;
}
